import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import { useAppStoreDispatch, useAppStoreSelector } from '../../../store';
import DrawerItem from './DrawerItem';
import HamburgerIcon from '../../general/components/HamburgerIcon';
import usePortals from '../../dashboard/Dashboard.hook';
import { toggleDrawer } from '../store';

function DrawerEl({
  drawerRef,
  // isHamburgerActive,
  // setIsHamburgerActive,
  /* navBarHeight, */
}: {
  drawerRef: React.RefObject<HTMLDivElement>;
  // isHamburgerActive: boolean;
  // setIsHamburgerActive: (
  //   isActive: boolean | ((prevState: boolean) => boolean)
  // ) => void;
  /* navBarHeight: string; */
}) {
  const postSettings = useAppStoreSelector((state) => state.settings);
  const dispatch = useAppStoreDispatch();
  const isHamburgerActive = useAppStoreSelector(
    (state) => state.app.data.modals.drawer.isDrawerOpen
  );
  const drawerWidth = postSettings.data?.sizes.drawer;

  const onPortalItemClickHandler = () => {
    dispatch(toggleDrawer(false));
    // setIsHamburgerActive(false);
  };

  const [portals] = usePortals();

  return (
    <>
      {isHamburgerActive && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.05)',
            backdropFilter: 'blur(1px)',
            zIndex: 900,
          }}
          onClick={() => dispatch(toggleDrawer(false))}
        />
      )}

      <Box sx={{ position: 'relative', zIndex: 1100 }}>
        <Box
          sx={{
            borderRadius: '0 0 0 4px',
            /* height: navBarHeight, */
            width: drawerWidth ? drawerWidth : '3.5rem',
          }}
        >
          <ListItem
            sx={{
              width: '100%',
              borderRadius: '0px 0px 0px 4px',
              height: '100%',
              p: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'background 0.15s ease',
            }}
          >
            <HamburgerIcon
              isActive={isHamburgerActive}
              /* navBarHeight={navBarHeight} */
            />
          </ListItem>
        </Box>
        {isHamburgerActive && (
          <Box
            sx={{
              position: 'absolute',
              width: '200px',
              height: '90vh',
              py: 1,
              my: 2,
              backgroundColor: (theme) => theme.palette.background.paper,
              boxShadow: (theme) => theme.shadows[3],
              zIndex: 1001,
              overflow: 'auto',
              borderRadius: '10px',
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(0,0,0,0.2)',
                borderRadius: '4px',
                borderTop: '10px solid transparent',
                borderBottom: '10px solid transparent',
                backgroundClip: 'padding-box',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: 'rgba(0,0,0,0.35)',
              },
            }}
          >
            <List
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '0 0.5rem',
              }}
            >
              {portals.map((portal, index) => (
                <DrawerItem
                  key={`${index}-${portal.portalName}`}
                  portalName={portal.portalName}
                  portalLink={`/portal/${portal.portalID}`}
                  setPortalDrawer={onPortalItemClickHandler}
                  portalWidgetImage={portal.portalWidgetImageValue}
                />
              ))}
            </List>
          </Box>
        )}
      </Box>
    </>
  );
}

export default DrawerEl;
